const AssetType = {
  offer: 'COURSE_PAGE',
  curriculumOffer: 'PATH_PAGE',
  checkpoint: 'CHECKPOINT_PAGE',
  managerCheckpoint: 'MANAGER_CHECKPOINT_PAGE',
  liveTraining: 'LIVE_TRAINING_PAGE',
  channel: 'CHANNEL_CARD_PAGE',
  channels: 'CHANNEL',
  channelPage: 'CHANNEL_PAGE'
};

export { AssetType };
export default AssetType;
